import { ORDER_APIS } from "@/api_framework/api_config";
import { IRxOrderCallConnectRequest, IRxOrderCallConnectResponse } from "@/api_framework/api_modals/Orders";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

type IRxOrderCallConnectResult = {
  status: boolean;
  message: string;
  data?: unknown;
};

export const useRxOrderCallConnectAPI = () => {
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (payload: IRxOrderCallConnectRequest): Promise<IRxOrderCallConnectResult> => {
    try {
      const endpoint = ORDER_APIS?.EXOTEL_CALL_CONNECT?.baseURL;

      if (!endpoint) {
        const message = "Exotel call endpoint is missing";
        toast.error(message);
        return { status: false, message };
      }

      if (!payload?.from_number || !payload?.to_number) {
        return { status: false, message: "from_number and to_number are required" };
      }

      const res = await axios.post<IRxOrderCallConnectResponse>(endpoint, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const response: IRxOrderCallConnectResult = {
        status: Boolean(res?.data?.status),
        message: res?.data?.message ?? "",
        data: res?.data?.data,
      };

      if (response.status && response.message) {
        toast.success(response.message);
      } else if (!response.status && response.message) {
        toast.error(response.message);
      }

      return response;
    } catch (error: unknown) {
      const axiosError = error as AxiosError<IRxOrderCallConnectResponse>;
      sendCurl(axiosError?.config?.["curlCommand"]);
      const message = axiosError?.response?.data?.message || axiosError?.message || "Request failed";
      toast.error(message);
      return { status: false, message };
    }
  }, [sendCurl]);

  return execute;
};
